<template>
    <div v-show="show" class="bg notify">
        <div class="box-container">
            <div class="title">
                <img v-show="config.showIcon && !config.showAlert" src="@assets/img/mediaPublish/notifyOn.png" alt="">
                <img v-show="config.showAlert" src="@assets/img/mediaPublish/alertIcon.png" alt="">
                <p v-html="config.title"></p>
            </div>

            <div v-show="config.title" :class="{content: true,on: !config.showIcon}" v-html="config.content"></div>

            <div class="btns">
                <p @click="confirm" class="btn on">{{config.btn1}}</p>
                <p @click="cancel" class="btn">{{config.btn2}}</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                config: {},
                call: null,
                show: true
            }
        },
        methods: {
            open(config,call) {
                this.config = config;
                this.call = call;
                this.show = true
            },
            close() {
                this.show = false
            },
            confirm() {
                this.call(true)
                this.close()
            },
            cancel() {
                this.call(false)
                this.close()
            }
        }
    }
</script>

<style lang="less" scoped>
@import "../../assets/css/global.less";
.bg.notify {
    position: relative;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(50, 59, 75, 0.3);
    border-radius: 2px;
    backdrop-filter: blur(1.6px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100000003;

    .box-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 472px;
        min-height: 136px;
        padding: 30px 32px 24px;
        background: #F9F9F9;
        border-radius: 4px;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
        box-sizing: border-box;

        .title {
            display: flex;
            flex-direction: row;
            // align-items: center;

            img {
                width: 22px;
                height: 22px;
                margin-right: 16px;
            }

            p {
                font-size: 16px;
                font-weight: bold;
                color: #323B4B;
                line-height: 24px;
            }
        }

        .content {
            width: 100%;
            padding-left: 38px;
            box-sizing: border-box;
            margin-top: 12px;
            font-size: 14px;
            line-height: 22px;
            color: #666666;
            margin-bottom: 24px;

            &.on {
                padding-left: 0;
                margin-bottom: 24px;
            }
        }

        .btns {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;

            .btn {
                // width: 65px;
                height: 32px;
                background: #B9C3C3;
                font-size: 14px;
                font-weight: bold;
                color: #FFFFFF;
                line-height: 32px;
                border-radius: 4px;
                text-align: center;
                user-select: none;
                cursor: pointer;
                padding: 0 12px;
                box-sizing: border-box;

                &.on {
                    background: #41B48C;
                    margin-right: 8px;
                }
            }
        }
    }
}
</style>

<style lang="less">
.bg > .box-container > .content em {
    color: #41B48C;
    font-style: normal;
}
</style>